<template>
  <v-dialog max-width="600px" v-model="visible">
    <v-btn flat color="green" slot="activator" class="mb-2">
      <span>Add Event</span>
      <v-icon right>add</v-icon>
    </v-btn>

    <v-card>
      <v-card-title>
        <h2>Add a new event</h2>
      </v-card-title>

      <v-card-text>
        <v-form class="px-3" ref="form">
          <v-text-field label="Title" v-model="title" :rules="requiredRules" outline />
          <v-text-field label="Description" v-model="description" :rules="requiredRules" outline />
          <v-select :items="eventTypes" label="Event Type" v-model="type" :rules="requiredRules" outline />

          <br />

          <v-menu class="pr-2" :close-on-content-click="false" v-model="datePicker">
            <v-text-field
              slot="activator" label="Event Date"
              :value="formatDate" :rules="requiredRules"
              outline readonly />
            <v-date-picker v-model="date" no-title>
              <v-spacer />

              <v-btn flat color="blue" @click="saveDate">OK</v-btn>
            </v-date-picker>
          </v-menu>

          <v-menu class="pl-2" :close-on-content-click="false" ref="menu">
            <v-text-field
              slot="activator" label="Event Time"
              :value="time" :rules="requiredRules"
              outline readonly />
            <v-time-picker v-model="time" :allowed-minutes="allowedMinutes">
              <v-spacer />

              <v-btn flat color="blue" @click="$refs.menu.save(time)">OK</v-btn>
            </v-time-picker>
          </v-menu>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <upload-button color="blue" class="mb-2" title="Import iCal Events" accept=".ics"
                       :fileChangedCallback="fileChanged" />
        <v-progress-circular indeterminate class="mb-2" v-if="importing" />

        <v-spacer />

        <v-btn color="blue" class="mr-4 mb-2" @click="submitEvent()">
          <span>Create</span>
          <v-icon right>add</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UploadButton from 'vuetify-upload-button';
import parse from 'date-fns/parse';
import format from 'date-fns/format';
import addHours from 'date-fns/add_hours';
import addMinutes from 'date-fns/add_minutes';
import {Events} from '../fbConfig';
import iCalParser from '../utils/iCalParser';

export default {
  name: 'AddEventDialog',
  components: {UploadButton},
  data() {
    return {
      importing: false,
      visible: false,
      datePicker: false,
      title: '',
      description: '',
      type: null,
      date: null,
      time: null,
      eventTypes: [
        'Game',
        'Competition',
        'Special'
      ],
      requiredRules: [
        value => !!value || 'This field is required'
      ]
    };
  },
  methods: {
    saveDate() {
      this.datePicker = false; // Close the date picker
      if (this.date === null || this.type === 'Special') {
        // Return if there is no date set, that way we don't get some garbage value as the day of week
        return;
      }

      const dayOfWeek = parse(this.date).getDay();
      // Check if it's Friday or Saturday, if it is, then we want to start the event at 18:30,
      // otherwise it'll start at 17:30
      if (dayOfWeek === 5 || dayOfWeek === 6) {
        this.time = '18:30';
      } else {
        this.time = '17:30';
      }
    },
    submitEvent() {
      if (this.$refs.form.validate() === false) {
        return;
      }

      const time = this.time.split(':');
      let date = addHours(parse(this.date), time[0]);
      date = addMinutes(date, time[1]);

      const event = {
        title: this.title,
        details: this.description,
        date,
        assignments: null,
        type: this.type
      };

      Events.add(event).then(() => {
        this.visible = false;
        this.$refs.form.reset();
      });
    },
    fileChanged(file) {
      this.importing = true;

      const reader = new FileReader();
      reader.onload = () => {
        const events = iCalParser(reader.result);

        for (const event of events) {
          Events.add(event).then(() => {
            console.log('bulk::added event');
          });
        }

        this.importing = false;
        this.visible = false;
      };

      reader.readAsText(file);
    },
    allowedMinutes: m => m % 5 === 0
  },
  computed: {
    formatDate() {
      return this.date ? format(this.date, 'MMMM Do, YYYY') : '';
    }
  }
};
</script>
